import React from 'react';
export function ForYourBabySection() {
  return <section id="do-it-for-them" className="bg-[#faf7f4] py-[100px] px-6 font-serif overflow-hidden" data-id="element-160">
      <div className="max-w-[1100px] mx-auto flex flex-col-reverse md:flex-row items-center gap-10 md:gap-20 flex-wrap justify-center" data-id="element-161">
        {/* ── LEFT COLUMN: COPY ── */}
        <div className="flex-1 min-w-[300px] md:min-w-[380px] max-w-full md:max-w-[500px] flex flex-col gap-7 text-left" data-id="element-162">
          {/* Top badge */}
          <span className="inline-block w-fit bg-[#f0e8e0] text-[#8B5E52] text-xs font-sans font-bold tracking-[2.5px] uppercase py-[7px] px-[18px] rounded-full" data-id="element-163">
            ✦ Una decisión que lo cambia todo
          </span>

          {/* Main title */}
          <h2 className="text-[clamp(30px,4vw,46px)] text-[#2c1810] leading-[1.25] m-0 font-bold" data-id="element-164">
            Hazlo por ellos.
            <br data-id="element-165" />
            <span className="text-[#8B5E52] italic font-normal" data-id="element-166">
              Hazlo por ti también.
            </span>
          </h2>

          {/* Decorative divider line */}
          <div className="w-[60px] h-[3px] bg-[#c9a090] rounded-sm" aria-hidden="true" data-id="element-167" />

          {/* Paragraph 1 — For the baby */}
          <p className="text-[17px] leading-[1.85] text-[#5a4a42] font-sans m-0" data-id="element-168">
            Esos pequeños pies que ves ahora{' '}
            <strong className="text-[#2c1810]" data-id="element-169">
              no serán pequeños por mucho tiempo.
            </strong>{' '}
            El primer año de vida es la única ventana en la que el cerebro de tu
            bebé se construye a una velocidad que nunca más se repetirá. Lo que
            sucede en estos 365 días{' '}
            <strong className="text-[#2c1810]" data-id="element-170">
              importa más que cualquier otra cosa
            </strong>{' '}
            que harás como padre o madre.
          </p>

          {/* Paragraph 2 — For the parent */}
          <p className="text-[17px] leading-[1.85] text-[#5a4a42] font-sans m-0" data-id="element-171">
            Pero esto también es cierto:{' '}
            <strong className="text-[#2c1810]" data-id="element-172">
              unos padres exhaustos no pueden dar lo mejor de sí.
            </strong>{' '}
            Necesitas dormir. Necesitas claridad. Necesitas saber que lo estás
            haciendo bien. Este protocolo no es solo para tu bebé —{' '}
            <strong className="text-[#2c1810]" data-id="element-173">
              es para que tú también puedas volver a respirar.
            </strong>
          </p>

          {/* 3 emotional micro-points */}
          <div className="flex flex-col gap-3.5 mt-1" role="list" aria-label="Beneficios clave" data-id="element-174">
            {[{
            icon: '🤍',
            text: 'Para que cada momento cuente, sin culpa y sin miedo.'
          }, {
            icon: '🧠',
            text: 'Para que tu bebé llegue al año con una base neurológica sólida.'
          }, {
            icon: '🌙',
            text: 'Para que puedas volver a dormir y realmente disfrutar esta etapa.'
          }].map((item, i) => <div key={i} role="listitem" className="flex items-start gap-3.5 bg-white border-[1.5px] border-[#ede5df] rounded-2xl py-3.5 px-[18px] shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-175">
                <span className="text-[20px] leading-none" aria-hidden="true" data-id="element-176">
                  {item.icon}
                </span>
                <p className="m-0 text-[15px] leading-[1.6] text-[#5a4a42] font-sans" data-id="element-177">
                  {item.text}
                </p>
              </div>)}
          </div>

          {/* Closing quote */}
          <blockquote className="mt-2 mb-0 py-5 px-6 bg-[#f5ede8] border-l-4 border-[#c9a090] rounded-r-2xl italic text-base text-[#7a5a50] leading-[1.7] font-serif" data-id="element-178">
            "No se trata de ser los padres perfectos. Se trata de ser los padres{' '}
            <strong className="font-bold" data-id="element-179">presentes y preparados</strong> que tu
            bebé necesita."
          </blockquote>
        </div>

        {/* ── RIGHT COLUMN: IMAGE ── */}
        <div className="flex-1 min-w-[300px] md:min-w-[380px] max-w-full md:max-w-[480px] w-full relative" data-id="element-180">
          {/* Decorative background circle */}
          <div className="hidden md:block absolute top-[-30px] right-[-30px] w-[300px] h-[300px] bg-[#f0e8e0] rounded-full z-0 opacity-60" aria-hidden="true" data-id="element-181" />

          {/* Main image */}
          <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_1_abr_2026_12_15_07_a.m..png?v=1775852001" alt="El Primer Año de tu Bebé — Protocolo B.E.BE 365" width="480" height="480" className="w-full h-auto rounded-3xl shadow-[0_30px_80px_rgba(0,0,0,0.15)] relative z-10 block" data-id="element-182" />

          {/* Floating card — social proof */}
          <div className="absolute bottom-6 left-[-20px] bg-white rounded-2xl py-3.5 px-5 shadow-[0_10px_40px_rgba(0,0,0,0.12)] z-20 flex items-center gap-3 max-w-[240px]" data-id="element-183">
            <span className="text-[28px]" data-id="element-184">👶</span>
            <div data-id="element-185">
              <p className="m-0 text-sm font-bold text-[#2c1810] font-sans" data-id="element-186">
                +2,400 familias
              </p>
              <p className="m-0 text-sm text-[#9a8880] font-sans" data-id="element-187">
                ya viven esta diferencia
              </p>
            </div>
          </div>

          {/* Floating card — stars */}
          <div className="absolute top-6 right-[-10px] bg-white rounded-2xl py-3 px-[18px] shadow-[0_10px_40px_rgba(0,0,0,0.10)] z-20 text-center" data-id="element-188">
            <p className="m-0 text-base tracking-[2px]" data-id="element-189">⭐⭐⭐⭐⭐</p>
            <p className="mt-1 mb-0 text-xs text-[#9a8880] font-sans font-semibold" data-id="element-190">
              4.9 / 5 · 847 reseñas
            </p>
          </div>
        </div>
      </div>
    </section>;
}